

import {useEffect, useState} from "react";
import {GetApiPodcastEpisodesOrderByEnum} from "../generated";

export const OrderBy = (props: {
    onChange: (what?:GetApiPodcastEpisodesOrderByEnum) => void,
    orderBy?: string,
    className?: string
}) => {
    const [orderBy, setOrderBy] = useState(() => {
        if (props.orderBy && props.orderBy in GetApiPodcastEpisodesOrderByEnum)
            return props.orderBy;
        return undefined;
    });
    useEffect(() => {
        if (props.orderBy && props.orderBy in GetApiPodcastEpisodesOrderByEnum) {
            setOrderBy(props.orderBy);
        }
        else
        {
            setOrderBy(undefined);
        }
    }, [props.orderBy]);

    return <div className={`d-flex align-items-center `}>
            Seřadit&nbsp;podle:&nbsp;&nbsp;&nbsp;
            <select  value={orderBy} onChange={e=>{
                setOrderBy((e.target.value  as GetApiPodcastEpisodesOrderByEnum)|| undefined);
                props.onChange((e.target.value || undefined) as GetApiPodcastEpisodesOrderByEnum);
            }} className={"selectMenu form-select"} >
                <option value={""} >Zveřejnění</option>
                <option value={"Listened"} >Rozposlouchané</option>
            </select>
        </div>
}